import {
  FETCH_TASK_STATISTIC_SUCCESS,
  FETCH_TASK_STATISTIC_FAILURE,
} from './actions';
import { Map } from 'immutable';
import { ApiResponseHelper, moment } from 'omni-common-ui';
import TaskStatistic from './model';

export default function taskStatisticResult(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_TASK_STATISTIC_SUCCESS:
      return onSuccess(action);
    case FETCH_TASK_STATISTIC_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

function onSuccess(action) {
  const taskStatistics = [];
  const result = {
    CO: {
      status: 'Completed',
      percentage: 0,
      count: 0,
    },
    PE: {
      status: 'Pending',
      percentage: 0,
      count: 0,
    },
    OD: {
      status: 'Overdue',
      percentage: 0,
      count: 0,
    },
    EX: {
      status: 'Expired',
      percentage: 0,
      count: 0,
    },
  };

  const statisticFromDateTime = action.payload.statisticFromDateTime ?
      moment(action.payload.statisticFromDateTime).format('YYYY-MM-DD') : '';

  if (action.payload.taskStatistics) {
    action.payload.taskStatistics.map((statistic) => {
      taskStatistics.push(TaskStatistic.create(statistic));
      return false;
    });
  }

  const totalCount = taskStatistics.length === 0 ?
      0 :
      taskStatistics.reduce((before, next) => {
        const newCount = before.taskCount + next.taskCount;
        return Object.assign({}, next, { taskCount: newCount });
      }).taskCount;

  if (totalCount > 0) {
    taskStatistics.map((taskStatistic) => {
      result[taskStatistic.taskStatusCode].percentage =
        ((taskStatistic.taskCount / totalCount) * 100);
      result[taskStatistic.taskStatusCode].count = taskStatistic.taskCount;

      return false;
    });
  }
  return { taskStatistics: Object.values(result), statisticFromDateTime };
}



// WEBPACK FOOTER //
// ./data/Tasks/TaskStatistic/reducer.js